import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-site",
  "use": "icon-site-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-site\"><defs><style type=\"text/css\"></style></defs><path d=\"M514.529 140.428c-156.365 0-283.125 125.12-283.125 279.465s283.125 459.123 283.125 459.123 283.125-304.778 283.125-459.123-126.76-279.465-283.125-279.465z m0 418.533c-74.783 0-135.408-60.624-135.408-135.408s60.625-135.408 135.408-135.408 135.408 60.624 135.408 135.408c0 74.783-60.625 135.408-135.408 135.408z\" fill=\"\" p-id=\"2630\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/site.svg
// module id = Bd3Y
// module chunks = 44